import type { RowValues } from 'exceljs';
import { Buffer } from 'buffer';
import { readTextFromBuffer } from '@lmt/shared-types';
/*
   This functions triggers standard browser 'Download file' dialog.
   In Chrome it just saves the file to Downloads folder and shows the file in bottom toolbar.
 */
export function triggerDownloadFileDialog(blob: Blob, fileName: string) {
  const data = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = data;
  link.download = fileName;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

export async function readFileAsBlob(file: File): Promise<Blob> {
  const buffer = await readFileAsBuffer(file);
  return new Blob([new Uint8Array(buffer)], {
    type: file.type,
  });
}

export async function readFileAsBuffer(file: File): Promise<Buffer> {
  return new Promise<Buffer>((resolve, _reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      resolve(Buffer.from(e.target?.result as ArrayBuffer));
    };
    reader.readAsArrayBuffer(file);
  });
}

export async function readFileAsString(
  file: File,
  encoding?: string,
): Promise<string> {
  const buffer = await readFileAsBuffer(file);
  const str = readTextFromBuffer(buffer);
  return str;
}

export async function readFileAsExcel(file: File): Promise<RowValues[]> {
  const buffer = await readFileAsBuffer(file);
  const exceljs = await import('exceljs');
  const workbook = new exceljs.Workbook();
  await workbook.xlsx.load(buffer);
  const values = workbook.worksheets[0].getSheetValues();

  return values;
}
